<template>
    <div class="management" v-can="'settings_management.access'" v-if="isMounted">
        <ds-filter
            :data="list"
            :fields="filterFields"
            @resultFilter="resultFilter"
        />

        <ds-table
            :data="listFilter"
            :heads="heads"
            search
            :view-items="[10, 15, 20]"
            :max-items="10"
            expand
        >
            <template v-slot:header>
                <vs-button
                    v-can="'settings_management.create'"
                    @click="create"
                    class="mr-4 whitespace-no-wrap"
                    color="primary"
                    type="border"
                    v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                >
                    {{ $t('buttons.Create_Relation') }}
                </vs-button>
                <vs-button
                    v-can:show="'settings_management.create'"
                    disabled
                    class="mr-4 whitespace-no-wrap"
                    color="primary"
                    type="border"
                    v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                >
                    {{ $t('buttons.Create_Relation') }}
                </vs-button>
            </template>

            <template v-slot:teams="{teams}">
                <div class="flex items-center cursor-pointer">
                    <vs-chip v-tooltip.position.left="teams.teams.map(item => item.name || item.id).join('</br>')">
                        <vs-icon color="primary" v-bind="$iconData('icon-users', 'fi-rr-users')"></vs-icon>
                        <div class="ml-2">{{ teams.team_names_length }}</div>
                    </vs-chip>
                </div>
            </template>

            <template v-slot:actions="{actions}">
                <vs-button v-can="'settings_management.update'" radius color="primary" type="flat" v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')" @click.stop="update(actions)"
                           v-tooltip="$t('modals.Edit_relation')"></vs-button>
                <vs-button v-can:show="'settings_management.update'" radius color="primary" type="flat" v-bind="$iconData('icon-eye', 'fi-rr-eye')" @click.stop="update(actions)"
                           v-tooltip="$t('modals.list_relation')"></vs-button>
            </template>

            <template v-slot:expand="{expand}">
                <ds-table
                    :data="expand.teams"
                    :heads="expandHeader"
                    :max-items="expand.teams.length"
                    spacer
                    :paginate="false"
                ></ds-table>
            </template>
        </ds-table>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import EventBus from "@/store/eventBus"
import send from "@/utils/fetch"
import {dataSort, checkPermission, utils} from '@/utils/mixins'

export default {
    mixins: [dataSort, checkPermission, utils],
    data() {
        return {
            isMounted: false,
            list: [],
            listFilter: [],
            heads: [
                {name: 'global.Manager', key: 'name', sortKey: 'name', value: 'name', display: true},
                {name: 'global.Team', key: 'teams', sortKey: 'team_names_length', value: 'teams', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', display: true},
            ],
            expandHeader: [
                {name: 'global.Team', key: 'teams', sortKey: 'name', value: 'name', display: true}
            ],
            optionsList: {}
        }
    },

    computed: {
        filterFields() {
            return [
                {name: 'global.Manager', type: 'select', label: 'name', field: 'hash'},
                {name: 'global.Team', key: 'teams', type: 'select', label: 'name', field: 'id', sortKey: this.isPermission('settings_team.show_team_name') ? 'label' : 'value'},
            ]
        }
    },

    methods: {
        resultFilter(data) {
            this.listFilter = data
        },

        create() {
            EventBus.$emit('emitPopupEvent', {type: 'createRelation', name: this.$t('buttons.Create_Relation'), data: this.optionsList})
        },

        update(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'editRelation',
                name: !this.isPermission('settings_management.update') ? this.$t('modals.list_relation') : this.$t('modals.Edit_relation'),
                data: {
                    data,
                    teams: this.optionsList.teams || {}
                }
            })
        },

        async get() {
            try {
                this.list = await send(this.$url.settings_manager.get, 'GET')
                    .then(response => response.data.result.managers)
                    .then(response => {
                        return response.map(item => {
                            item.team_names_length = item.teams.length
                            item.teams = this.createNameById(item.teams)
                            return item
                        })
                    })

                await this.getData()

                this.isMounted = true
            } catch (e) {
                this.isMounted = false
                new ErrorHandler(e).send
            }
        },

        async getData() {
            try {
                this.optionsList = await send(this.$url.settings_manager.data, 'GET')
                    .then(response => response.data.result)
                    .then(response => {
                        response.users = response.users.filter(item => !this.list.map(i => i.hash).includes(item.hash))

                        if (!this.isPermission('settings_team.show_team_name')) {
                            response.teams = this.createNameById(response.teams)
                        }

                        return response
                    })
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        await this.get()

        EventBus.$on('actionRelation', async () => {
            await this.get()
        })
    },

    destroyed() {
        EventBus.$off('actionRelation')
    }
}
</script>
